var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1679 1668",
    style: {
      enableBackground: "new 0 0 1679 1668"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A2A2A2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "dragon"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1679,506.8h-313.8v-402l-315,297L845.6,11.6L839.5,0l-6.1,11.6L628.8,401.8l-315-297v402H0L301.8,834 c0,0-33,341.8,192,491.9c0,0,201,141.2,219,342.1h253.5c18-200.9,219-342.1,219-342.1c225-150,192-491.9,192-491.9L1679,506.8z  M724,1096c0,0-178-90-236-332l236,174V1096z M970,1096V938l236-174C1148,1006,970,1096,970,1096z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragon);
export default __webpack_public_path__ + "static/media/dragon.5709286b7f52f8c64f2f246c9524d4a9.svg";
export { ForwardRef as ReactComponent };